/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MedicareAssessmentFormOptions } from './MedicareAssessmentFormOptions';
import {
    MedicareAssessmentFormOptionsFromJSON,
    MedicareAssessmentFormOptionsFromJSONTyped,
    MedicareAssessmentFormOptionsToJSON,
    MedicareAssessmentFormOptionsToJSONTyped,
} from './MedicareAssessmentFormOptions';

/**
 * 
 * @export
 * @interface GetMedicareAssessmentFormOptions200Response
 */
export interface GetMedicareAssessmentFormOptions200Response {
    /**
     * 
     */
    data?: MedicareAssessmentFormOptions;
}

/**
 * Check if a given object implements the GetMedicareAssessmentFormOptions200Response interface.
 */
export function instanceOfGetMedicareAssessmentFormOptions200Response(value: object): value is GetMedicareAssessmentFormOptions200Response {
    return true;
}

export function GetMedicareAssessmentFormOptions200ResponseFromJSON(json: any): GetMedicareAssessmentFormOptions200Response {
    return GetMedicareAssessmentFormOptions200ResponseFromJSONTyped(json, false);
}

export function GetMedicareAssessmentFormOptions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMedicareAssessmentFormOptions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : MedicareAssessmentFormOptionsFromJSON(json['data']),
    };
}

export function GetMedicareAssessmentFormOptions200ResponseToJSON(json: any): GetMedicareAssessmentFormOptions200Response {
    return GetMedicareAssessmentFormOptions200ResponseToJSONTyped(json, false);
}

export function GetMedicareAssessmentFormOptions200ResponseToJSONTyped(value?: GetMedicareAssessmentFormOptions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': MedicareAssessmentFormOptionsToJSON(value['data']),
    };
}

